export const PBA_EXISTING_PERMISSIONS_REASON =
  'To assign this user as a Partner Branch Admin, you must first clear their existing permissions. Alternatively, you can invite a new user profile using an alias: name_surname+admin@domain.com';
